
import { Placement } from '@post-office/placements-frontend/statuspage-create-component-spotlight-placement';
export default Placement;
